// adminfrontend/src/admin_ui/services/adminComplianceApi.js
import adminApiClient from "./adminApiClient";

const adminComplianceApi = {
  async overview(params) {
    try {
      const res = await adminApiClient.get("/api/compliance/overview", { params });
      return res.data;
    } catch (e) {
      return { ok: false, error: e?.response?.data?.error || e.message || "Request failed" };
    }
  },

  async verifications(params) {
    try {
      const res = await adminApiClient.get("/api/compliance/verifications", { params });
      return res.data;
    } catch (e) {
      return { ok: false, error: e?.response?.data?.error || e.message || "Request failed" };
    }
  },

  async shipments(params) {
    try {
      const res = await adminApiClient.get("/api/compliance/shipments", { params });
      return res.data;
    } catch (e) {
      return { ok: false, error: e?.response?.data?.error || e.message || "Request failed" };
    }
  },
};

export default adminComplianceApi;
